import { render, staticRenderFns } from "./projectsSetting.vue?vue&type=template&id=a1ecbece&scoped=true"
import script from "./projectsSetting.vue?vue&type=script&lang=js"
export * from "./projectsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ecbece",
  null
  
)

export default component.exports